import Rete from 'rete';

export default {
  // When the bound element is inserted into the DOM...
  inserted: function(el, binding, vnode) {
    const caseLogicEditor = findCaseLogicEditorInParents(vnode.context);
    if (!caseLogicEditor) {
      return;
    }
    caseLogicEditor.on('zoom', (params) => {
      const { event } = params;
      // If we are scrolling over the select element
      // we don't want it to close
      // We only want the select to close when we scroll
      // outside the select to zoom
      if (
        event &&
        (el.contains(event.target) ||
          // Select menus are adjacent to their trigger element
          (el.parentElement && el.parentElement.contains(event.target)))
      ) {
        return false;
      }
      if (vnode.componentInstance.visible) {
        vnode.componentInstance.visible = false;
      }
      if (vnode.componentInstance && vnode.componentInstance.MdMenu) {
        // if vue material mdmenu
        vnode.componentInstance.MdMenu.active = false;
      }
      if (vnode.componentInstance.showSelect) {
        vnode.componentInstance.showSelect = false;
      }
    });
  },
};

function findCaseLogicEditorInParents(componentInstance) {
  const caseLogicEditor = componentInstance.editor || componentInstance.emitter;
  if (caseLogicEditor && caseLogicEditor instanceof Rete.NodeEditor) {
    return caseLogicEditor;
  }
  if (componentInstance.$parent) {
    return findCaseLogicEditorInParents(componentInstance.$parent);
  }
  return null;
}
